import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

const catalogResource = (bookingToken: string) =>
  `/public/booking/${encodeURIComponent(bookingToken)}/club-plans`;

export interface PublicClubCatalogPlan {
  id: number;
  name: string;
  description?: string | null;
  price: number;
  billing_interval?: string | null;
  monthly_visit_limit?: number | null;
}

export interface PublicClubCatalogData {
  studio_name: string | null;
  has_plans: boolean;
  plans: PublicClubCatalogPlan[];
  plans_url: string;
}

export interface PublicClubCatalogJoinResult {
  url: string;
  token: string;
  expires_at: number;
  plan_id: number;
}

export const getPublicClubCatalog = (
  bookingToken: string
): Promise<ApiResponse<PublicClubCatalogData>> =>
  api.get<ApiResponse<PublicClubCatalogData>>(catalogResource(bookingToken));

export const postPublicClubCatalogJoin = (
  bookingToken: string,
  payload: {
    name: string;
    country_code: string;
    phone_number: string;
    client_subscription_plan_id: number;
  }
): Promise<ApiResponse<PublicClubCatalogJoinResult>> =>
  api.create<ApiResponse<PublicClubCatalogJoinResult>>(
    `${catalogResource(bookingToken)}/join`,
    payload
  );
